import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { inventory } from '../api/methods';
/**
 * Inventory hooks (#546 Phase 2). On-hand + ledger are open to every role
 * (inventory_view); cost history is finance-only; the track-inventory toggle is
 * manager+ (inventory_config). Costs are redacted server-side for non-finance.
 */
export const inventoryKeys = {
    all: ['inventory'],
    onHand: (businessUnitId) => ['inventory', 'on-hand', businessUnitId ?? 'default'],
    locations: (businessUnitId) => ['inventory', 'locations', businessUnitId ?? 'default'],
    ledger: (qbItemId, businessUnitId) => ['inventory', 'ledger', qbItemId, businessUnitId ?? 'default'],
    costHistory: (qbItemId, businessUnitId) => ['inventory', 'cost-history', qbItemId, businessUnitId ?? 'default'],
};
/** On-hand quantities for the BU (all roles). */
export function useInventoryOnHand(businessUnitId, enabled = true) {
    return useQuery({
        queryKey: inventoryKeys.onHand(businessUnitId),
        queryFn: () => inventory.onHand(businessUnitId).then((r) => r.items),
        enabled,
        staleTime: 30_000,
    });
}
/** Active stock locations (receive-form picker). */
export function useInventoryLocations(businessUnitId, enabled = true) {
    return useQuery({
        queryKey: inventoryKeys.locations(businessUnitId),
        queryFn: () => inventory.locations(businessUnitId).then((r) => r.locations),
        enabled,
        staleTime: 5 * 60_000,
    });
}
/** Per-vendor cost timeline for one item (finance only; lazy). */
export function useItemCostHistory(qbItemId, enabled = false, businessUnitId) {
    return useQuery({
        queryKey: inventoryKeys.costHistory(qbItemId ?? '', businessUnitId),
        queryFn: () => inventory.costHistory(qbItemId, businessUnitId).then((r) => r.history),
        enabled: enabled && !!qbItemId,
        staleTime: 15_000,
    });
}
/** Toggle track_inventory on an item (manager+). */
export function useSetTrackInventory() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ qbItemId, tracked, businessUnitId }) => inventory.setTrackInventory(qbItemId, tracked, businessUnitId).then((r) => r.item),
        onSuccess: () => {
            // On-hand list filters by tracked items; refresh it.
            qc.invalidateQueries({ queryKey: inventoryKeys.all });
        },
    });
}
//# sourceMappingURL=useInventory.js.map